<!-- Navigation -->
<calsoft-vertical-navigation class="theme-dark"
                          [appearance]="navigationAppearance"
                          [mode]="isScreenSmall ? 'over' : 'side'"
                          [name]="'mainNavigation'"
                          [navigation]="data.navigation.default[0]"
                          [opened]="!isScreenSmall">

    <div calsoftVerticalNavigationContentHeader>
        <div class="logo">
          <img [src]="path" onerror="this.src='assets/images/logo/2.png';" alt="">
        </div>
    </div>

</calsoft-vertical-navigation>

<!-- Wrapper -->
<div class="wrapper">

    <!-- Header -->
    <div class="header">

        <!-- Navigation toggle button -->
        <button [attr.guide]="'dense-btn-1' + '__' + sanitizeUrl(url)" class="navigation-toggle-button"
                mat-icon-button
                (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'menu'"></mat-icon>
        </button>

        <!-- Navigation appearance toggle button -->
        <button [attr.guide]="'dense-btn-2' + '__' + sanitizeUrl(url)" class="navigation-appearance-toggle-button"
                [ngClass]="{mirror: navigationAppearance === 'dense'}"
                mat-icon-button
                (click)="toggleNavigationAppearance()">
            <mat-icon [svgIcon]="'menu_open'"></mat-icon>
        </button>

        <!-- Spacer -->
        <div class="spacer"></div>

       
       

     
     

       
      

        <!-- Notifications -->
       

      
        <user></user>

    </div>

    <!-- Content -->
    <div class="content">

        <!-- *ngIf="true" hack is required here for router-outlet to work correctly. Otherwise,
             it won't register the changes on the layout and won't update the view. -->
        <router-outlet *ngIf="true"></router-outlet>

    </div>

    <!-- Footer -->
    <div class="footer">
        Calsoft &copy; {{currentYear}}
    </div>

</div>
